import cn from 'classnames';
import styles from './productCard.module.scss';

type ProductPriceProps = {
  startsAtPrice?: number;
  cheapestPrice?: number;
  hasSubscription?: boolean;
};
const ProductPrice = ({ startsAtPrice, cheapestPrice, hasSubscription }: ProductPriceProps) => {
  const reviewStyles = cn('p2', styles.reviews);

  if (!hasSubscription) {
    return (
      <p className={reviewStyles}>
        Starts at
        <span className="paddingLeft-tiny">${cheapestPrice}</span>
      </p>
    );
  }

  return (
    <p className={reviewStyles}>
      Starts at
      {!!startsAtPrice && <span className={cn('n300', styles.serviceRetailPrice)}>${startsAtPrice}</span>}
      <span className={styles.serviceMemberPrice}>${cheapestPrice} Member Price</span>
    </p>
  );
};

export default ProductPrice;
